/** System labels follow the interface language; authored titles and bodies stay as stored. */
export const notificationsMessages = {
	en: {
		bell: {
			agentNeedsHelp: "An agent needs help",
			ruleRefused: "“{rule}” was refused",
			label: "Notifications",
			markAllRead: "mark all as read",
			all: "All",
			unread: "Unread",
			nothingUnread: "Nothing left to read.",
			nothingHere: "Nothing here.",
			earlier: "Earlier",
			alsoBy: "· also by {medium}",
			open: "· open",
			dismiss: "Dismiss {title}",
			loadingMore: "loading…",
			loadMore: "load more · {shown} of {total}",
		},
		severity: {
			info: "info",
			warning: "warning",
			urgent: "urgent",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "e-mail",
		},
	},
	"pt-BR": {
		bell: {
			agentNeedsHelp: "Um agente precisa de ajuda",
			ruleRefused: "“{rule}” foi recusada",
			label: "Notificações",
			markAllRead: "marcar todas como lidas",
			all: "Todas",
			unread: "Não lidas",
			nothingUnread: "Nada por ler.",
			nothingHere: "Nada por aqui.",
			earlier: "Anteriores",
			alsoBy: "· também por {medium}",
			open: "· abrir",
			dismiss: "Dispensar {title}",
			loadingMore: "carregando…",
			loadMore: "carregar mais · {shown} de {total}",
		},
		severity: {
			info: "informativa",
			warning: "atenção",
			urgent: "urgente",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "e-mail",
		},
	},
	el: {
		bell: {
			agentNeedsHelp: "Ένας πράκτορας χρειάζεται βοήθεια",
			ruleRefused: "Ο κανόνας «{rule}» απορρίφθηκε",
			label: "Ειδοποιήσεις",
			markAllRead: "σήμανση όλων ως αναγνωσμένων",
			all: "Όλες",
			unread: "Μη αναγνωσμένες",
			nothingUnread: "Δεν έμεινε τίποτα για διάβασμα.",
			nothingHere: "Τίποτα εδώ.",
			earlier: "Προηγούμενες",
			alsoBy: "· επίσης μέσω {medium}",
			open: "· άνοιγμα",
			dismiss: "Παράβλεψη {title}",
			loadingMore: "φόρτωση…",
			loadMore: "φόρτωση περισσότερων · {shown} από {total}",
		},
		severity: {
			info: "ενημέρωση",
			warning: "προσοχή",
			urgent: "επείγον",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "email",
		},
	},
	es: {
		bell: {
			agentNeedsHelp: "Un agente necesita ayuda",
			ruleRefused: "«{rule}» fue rechazada",
			label: "Notificaciones",
			markAllRead: "marcar todas como leídas",
			all: "Todas",
			unread: "Sin leer",
			nothingUnread: "No queda nada por leer.",
			nothingHere: "Nada por aquí.",
			earlier: "Anteriores",
			alsoBy: "· también por {medium}",
			open: "· abrir",
			dismiss: "Descartar {title}",
			loadingMore: "cargando…",
			loadMore: "cargar más · {shown} de {total}",
		},
		severity: {
			info: "informativa",
			warning: "atención",
			urgent: "urgente",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "correo",
		},
	},
	fr: {
		bell: {
			agentNeedsHelp: "Un agent a besoin d’aide",
			ruleRefused: "« {rule} » a été refusée",
			label: "Notifications",
			markAllRead: "tout marquer comme lu",
			all: "Toutes",
			unread: "Non lues",
			nothingUnread: "Plus rien à lire.",
			nothingHere: "Rien ici.",
			earlier: "Précédentes",
			alsoBy: "· aussi par {medium}",
			open: "· ouvrir",
			dismiss: "Écarter {title}",
			loadingMore: "chargement…",
			loadMore: "charger plus · {shown} sur {total}",
		},
		severity: {
			info: "information",
			warning: "attention",
			urgent: "urgent",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "e-mail",
		},
	},
	it: {
		bell: {
			agentNeedsHelp: "Un agente ha bisogno di aiuto",
			ruleRefused: "«{rule}» è stata rifiutata",
			label: "Notifiche",
			markAllRead: "segna tutte come lette",
			all: "Tutte",
			unread: "Non lette",
			nothingUnread: "Non è rimasto niente da leggere.",
			nothingHere: "Niente qui.",
			earlier: "Precedenti",
			alsoBy: "· anche via {medium}",
			open: "· apri",
			dismiss: "Ignora {title}",
			loadingMore: "caricamento…",
			loadMore: "carica altre · {shown} di {total}",
		},
		severity: {
			info: "informativa",
			warning: "attenzione",
			urgent: "urgente",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "e-mail",
		},
	},
	de: {
		bell: {
			agentNeedsHelp: "Ein Agent benötigt Hilfe",
			ruleRefused: "„{rule}“ wurde abgelehnt",
			label: "Benachrichtigungen",
			markAllRead: "alle als gelesen markieren",
			all: "Alle",
			unread: "Ungelesen",
			nothingUnread: "Nichts mehr zu lesen.",
			nothingHere: "Nichts hier.",
			earlier: "Frühere",
			alsoBy: "· auch per {medium}",
			open: "· öffnen",
			dismiss: "{title} ausblenden",
			loadingMore: "lädt…",
			loadMore: "mehr laden · {shown} von {total}",
		},
		severity: {
			info: "Info",
			warning: "Achtung",
			urgent: "dringend",
		},
		medium: {
			whatsapp: "WhatsApp",
			email: "E-Mail",
		},
	},
} as const;
